//=============================================== This is the latest one =============================================================

// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   Navigate,
//   useNavigate,
// } from "react-router-dom";

// import Home from "./pages/Home";
// import Documentation from "./pages/Documentation";
// import Tools from "./pages/Tools";
// import ApiDocs from "./pages/ApiDocs";
// import Blog from "./pages/Blog";
// import Terms from "./pages/Terms";
// import Privacy from "./pages/Privacy";
// import Career from "./pages/Career";
// import UserJourney from "./pages/UserJourney";
// import Workspace from "./pages/Workspace";
// import Landing from "./pages/Landing";

// import PrivateRoute from "./routes/PrivateRoute";
// import PublicRoute from "./routes/PublicRoute";

// import AuthProvider, { useAuth } from "./contexts/AuthContext";
// import UIProvider from "./contexts/UIContext";
// import WorkspaceProvider from "./contexts/WorkspaceContext";
// import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// import { auth } from "./config/firebase.config";

// const App = () => {
//   const [showModal, setShowModal] = useState(true); // Set initial state to true
//   const isLoggedIn = localStorage.getItem("isLoggedIn")||'' ;
//   const [modalClosedManually, setModalClosedManually] = useState(false); // State to track if modal is closed manually

//   useEffect(() => {
//     if (!isLoggedIn) {
//       // Show modal after 10 seconds if not logged in and not closed manually
//       const timer = setTimeout(() => {
//         setShowModal(true);
//       }, 10000);

//       return () => clearTimeout(timer);
//     }
//   }, [isLoggedIn, modalClosedManually]);

//   const closeModal = () => {
//     console.log("Close modal clicked"); // Debugging statement
//     setShowModal(false);
//     setModalClosedManually(true); // Set state when modal is closed manually
//   };

//   return (
//     <Router>
//       <AuthProvider>
//         <UIProvider>
//           <Routes>
//             <Route path="/userJourney" element={<PrivateRoute />}>
//               <Route path="/userJourney" element={<UserJourney />} />
//             </Route>
//             <Route path="/workspace" element={<PublicRoute />}>
//               <Route
//                 path="/workspace"
//                 element={
//                   <WorkspaceProvider>
//                     <Workspace />
//                   </WorkspaceProvider>
//                 }
//               />
//             </Route>
//             <Route path="/" element={<PublicRoute />}>
//               <Route path="/" element={<Home />} />
//               <Route path="/tools" element={<Tools />} />
//               <Route path="/landing" element={<Landing/>} />
//               <Route path="/docs" element={<Documentation />} />
//               <Route path="/api" element={<ApiDocs />} />
//               <Route path="/blog" element={<Blog />} />
//               <Route path="/terms" element={<Terms />} />
//               <Route path="/privacy" element={<Privacy />} />
//               <Route path="/career" element={<Career />} />
//             </Route>
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Routes>
//           {showModal && !isLoggedIn && (
//             <Modal closeModal={closeModal} />
//           )}
//         </UIProvider>
//       </AuthProvider>
//     </Router>
//   );
// };

// const Modal = ({ closeModal }) => {
//   const { setUser } = useAuth();
//   const navigate = useNavigate();
//   const modalStyle = {
//     position: "fixed",
//     top: 0,
//     right: 0, // Adjusted position to top right
//     margin:'50px',
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     borderRadius: "20px",
//   };

//   const contentStyle = {
//     backgroundColor: "#0d0d0d",
//     padding: "20px",
//     borderRadius: "20px",
//     position: "relative",

//   };

//   const closeStyle = {
//     position: "absolute",
//     top: "10px",
//     right: "10px",
//     cursor: "pointer",
//   };
//   const handleGoogleSignUp = async () => {
//     try {
//       const provider = new GoogleAuthProvider();
//       const result = await signInWithPopup(auth, provider);
//       if (result.user.emailVerified) {
//         localStorage.setItem("token", result.user.accessToken);
//         setUser(result.user.emailVerified);
//         localStorage.setItem("isLoggedIn", true);
//         closeModal();
//         navigate("/workspace")
//         window.location.reload();
//       } else {
//         localStorage.setItem("isLoggedIn", "");
//       }
//     } catch (error) {
//       console.error("Error signing up with Google:", error.message);
//       // Add additional error handling logic here, such as displaying an error message to the user
//     }
//   };

//   return (
//     <div style={modalStyle}>
//       <div style={contentStyle}>
//         <span style={closeStyle} onClick={closeModal}>
//           &times;
//         </span>
//         <div style={{display:'flex',flexDirection:'row',gap:'10px',alignItems:'center',padding:'10px'}}>
//             <img src={require(`./assets/transparent-google-logo-google-logo-with-multicolored-g-and-1710875781697.png`)} style={{width:'15px',height:'15px'}}/>
//             <p style={{margin:'auto',fontSize:'.9rem',color:'white'}}>Sign in to Modalx.ai using google.com</p>
//         </div>
//         <p style={{color:'grey',width:'100%'}}>------------------------------------------------</p>
//         <button onClick={() =>handleGoogleSignUp()} style={{width:'100%',borderRadius:'10px',backgroundColor:'#0d6efd',fontSize:'.9rem',border:'none',padding:'10px'}}>Continue with google</button>
//       </div>
//     </div>
//   );
// };

// export default App;

//=============================================== Above code is the latest one =============================================================

import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import AuthProvider, { useAuth } from "./contexts/AuthContext";
import UIProvider from "./contexts/UIContext";
import WorkspaceProvider from "./contexts/WorkspaceContext";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "./config/firebase.config";
import { clearAppStorage } from './utils/storageUtils';
import {
  CreditRechargeProvider,
  useCreditRecharge,
} from "./contexts/CreditRechageContext";
import * as Sentry from "@sentry/react";
import {
  initializeGA,
  initializeMixPanel,
  trackNavigation,
  trackPageView,
} from "./config/analytics";
import {
  DailyLimitExceedProvider,
  useDailyLimitExceed,
} from "./contexts/DailyLimitExceedContext";
import { getValidToken } from "./contexts/AuthUtils";
import SMBGuard from "./contexts/SMBGuard";
import { ViAuthProvider, useViAuth } from "./contexts/ViAuthContext";
import { isViDomain } from "./constants/viIntegration";
import LogRocket from "logrocket";

// ── Route-level code splitting: each page is loaded only when first visited ──
const Home                     = lazy(() => import("./pages/Home"));
const Documentation            = lazy(() => import("./pages/Documentation"));
const Tools                    = lazy(() => import("./pages/Tools"));
const ApiDocs                  = lazy(() => import("./pages/ApiDocs"));
const Blog                     = lazy(() => import("./pages/Blog"));
const Terms                    = lazy(() => import("./pages/Terms"));
const Privacy                  = lazy(() => import("./pages/Privacy"));
const Career                   = lazy(() => import("./pages/Career"));
const UserJourney              = lazy(() => import("./pages/UserJourney"));
const Workspace                = lazy(() => import("./pages/Workspace"));
const Landing                  = lazy(() => import("./pages/Landing"));
const SignUpLogIn               = lazy(() => import("./components/navFoot/SignUpLogIn"));
const SignUpLoginForTesting     = lazy(() => import("./components/navFoot/SignUpLoginForTesting"));
const ClientLandingPage        = lazy(() => import("./components/Client_Side/ClientLandingPage"));
const PublicLinkView           = lazy(() => import("./components/PublicLinkView"));
const PaymentFail              = lazy(() => import("./pages/PaymentFail"));
const PaymentSuccess           = lazy(() => import("./pages/PaymentSuccess"));
const PresentationGallery      = lazy(() => import("./pages/PresentationGallery"));
const BlogArticle              = lazy(() => import("./pages/BlogArticle"));
const Aboutus                  = lazy(() => import("./pages/Aboutus"));
const Safety                   = lazy(() => import("./pages/Safety"));
const FAQ                      = lazy(() => import("./pages/FAQ"));
const TermsOfService           = lazy(() => import("./pages/TermsOfService"));
const PrivacyPolicy            = lazy(() => import("./pages/PrivacyPolicy"));
const Contact                  = lazy(() => import("./pages/Contact"));
const ImageGallery             = lazy(() => import("./pages/ImageGallery"));
const MarketingAgencies        = lazy(() => import("./pages/MarketingAgencies"));
const AudioGallery             = lazy(() => import("./pages/AudioGallery"));
const VideoGallery             = lazy(() => import("./pages/VideoGallery"));
const UseCases                 = lazy(() => import("./pages/UseCases"));
const CaseStudy                = lazy(() => import("./pages/CaseStudy"));
const LogOut                   = lazy(() => import("./pages/LogOut"));
const ShareProject             = lazy(() => import("./pages/ShareProject"));
const NewPage                  = lazy(() => import("./pages/NewPage"));
const WorkSpaceTrack           = lazy(() => import("./pages/WorkSpaceTrack").then(m => ({ default: m.WorkSpaceTrack })));
const WebSiteAllUpdatePage     = lazy(() => import("./pages/WebSiteAllUpdatePage"));
const PricePage                = lazy(() => import("./pages/PricePageNavBar"));
const PaymentSuccessForPlus    = lazy(() => import("./pages/PaymentSuccessForPlus"));
const HelpButtonMain           = lazy(() => import("./components/workspace/settingBar/HelpButton/HelpButtons"));
const Login                    = lazy(() => import("./components/navFoot/Login"));
const Signup                   = lazy(() => import("./components/navFoot/Signup"));
const ResetPassword            = lazy(() => import("./components/navFoot/ResetPassword"));
const BlogPage                 = lazy(() => import("./pages/BlogPage"));
const CallingAgent             = lazy(() => import("./pages/CallingAgent"));
const NewLandingPage           = lazy(() => import("./pages/NewLandingPage"));
const EmailVerificationPageFailed = lazy(() => import("./pages/EmailVerificationPageFailed"));
const VerifyEmailModal         = lazy(() => import("./components/navFoot/VerifyEmailModal"));
const VerifiedEmail            = lazy(() => import("./components/navFoot/VerifiedEmail"));
const PaymentSuccessForSmb     = lazy(() => import("./pages/PaymentSuccessForSmb"));
const VoiceAgent               = lazy(() => import("./components/workspace/sideBar/Voice_Agent/VoiceAgent"));
const UserGallery              = lazy(() => import("./pages/UserGallery"));
const VideoGenerate            = lazy(() => import("./pages/VideoGenerate"));
const Settings                 = lazy(() => import("./pages/Settings"));
const ProfileSettings          = lazy(() => import("./pages/ProfileSettings"));
const ReportIssue              = lazy(() => import("./pages/ReportIssue"));
const ViUnauthorized           = lazy(() => import("./pages/ViUnauthorized"));
const SmbSetupPage             = lazy(() => import("./pages/SmbSetup"));


const ViCallingAgentRedirect = () => {
  const isViUser = localStorage.getItem("isViUser") === "true";
  if (isViDomain() && isViUser) {
    return <Navigate to="/workspace" replace />;
  }
  return <CallingAgent />;
};

const ViRootRedirect = () => {
  if (isViDomain()) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('data') && params.get('checksum')) {
      // ViAuthWrapper handles the auth flow and shows the loading screen;
      // render nothing here to avoid a flash of the /vic page.
      return null;
    }
    // No auth params — redirect to /vic as before
    return <Navigate to="/vic" replace />;
  }
  return <Navigate to="/home" replace />;
};

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname); // Track page view
  }, [location]);

  return null;
};

const NavigationTracker = () => {
  const location = useLocation();
  const prevLocation = useRef(location.pathname);

  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      trackNavigation(prevLocation.current, location.pathname);
      prevLocation.current = location.pathname;
    }
  }, [location]);

  return null;
};

const WorkspaceLayout = () => {
  return (
    <>
      {/* <WorkspaceProvider> */}
      {/* Common logic or UI for all workspace routes */}
      <Sentry.ErrorBoundary>
        {/* Render child routes here */}
        <Outlet />
        <HelpButtonMain />
      </Sentry.ErrorBoundary>
      {/* </WorkspaceProvider> */}
    </>
  );
};

const VI_LOADING_MESSAGES = [
  'Brewing your experience...',
  'Warming up the pixels...',
  'Rolling out the red carpet...',
  'Tuning the airwaves...',
  'Polishing things up for you...',
  'Almost there, hang tight...',
  'Getting everything just right...',
  'Spinning up some magic...',
  'Waking up the hamsters...',
  'Setting the stage...',
];

const ViAuthWrapper = ({ children }) => {
  const { isViApp, isValidating, isAuthenticated, error } = useViAuth();
  const [timedOut, setTimedOut] = useState(false);
  // Minimum display duration so the loading message is readable (Row 19)
  const [minDurationPassed, setMinDurationPassed] = useState(false);
  const [loadingMsg] = useState(() => VI_LOADING_MESSAGES[Math.floor(Math.random() * VI_LOADING_MESSAGES.length)]);

  useEffect(() => {
    if (!isValidating) return;
    const timer = setTimeout(() => setTimedOut(true), 15000);
    return () => clearTimeout(timer);
  }, [isValidating]);

  // Ensure loading screen shows for at least 1.8 seconds (Row 19)
  useEffect(() => {
    const minTimer = setTimeout(() => setMinDurationPassed(true), 1800);
    return () => clearTimeout(minTimer);
  }, []);

  if (!isViApp) {
    return children;
  }

  if ((isValidating || !minDurationPassed) && !timedOut) {
    const theme = localStorage.getItem('theme') || 'dark';
    const isDark = theme !== 'light';
    const bg = isDark ? '#171A2D' : '#F5F6FA';
    const fg = isDark ? '#FFFFFF' : '#1B1D2E';
    const spinBorder = isDark ? 'rgba(255,255,255,0.15)' : 'rgba(27,29,46,0.15)';
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: bg,
        color: fg,
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        fontSize: '16px',
        gap: '16px',
      }}>
        {/* Row 20: inject keyframes so the spinner actually animates */}
        <style>{`
          @keyframes vi-spin {
            from { transform: rotate(0deg); }
            to   { transform: rotate(360deg); }
          }
        `}</style>
        <div style={{
          width: 40,
          height: 40,
          borderWidth: 3,
          borderStyle: 'solid',
          borderColor: spinBorder,
          borderTopColor: fg,
          borderRadius: '50%',
          animation: 'vi-spin 0.8s linear infinite',
        }} />
        <p style={{ margin: 0, opacity: 0.85, textAlign: 'center', padding: '0 24px' }}>{loadingMsg}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <ViUnauthorized error={timedOut ? 'AUTH_TIMEOUT' : error} />;
  }

  return children;
};

// Removes the Vi preloader only after Suspense has committed all lazy routes to the DOM.
// Ensures a minimum visible duration so the loading message is always readable.
const PreloaderRemover = () => {
  useEffect(() => {
    const preloader = document.getElementById('vi-preloader');
    if (!preloader) return;
    const MIN_SHOW_MS = 2500;
    const elapsed = window._preloaderStart ? Date.now() - window._preloaderStart : MIN_SHOW_MS;
    const delay = Math.max(0, MIN_SHOW_MS - elapsed);
    const t = setTimeout(() => {
      preloader.classList.add('vi-preloader-hide');
      setTimeout(() => preloader.remove(), 400);
    }, delay);
    return () => clearTimeout(t);
  }, []);
  return null;
};

const App = () => {
  const [showModal, setShowModal] = useState(true); // Set initial state to true
  const isLoggedIn = localStorage.getItem("isLoggedIn") || "";
  const [modalClosedManually, setModalClosedManually] = useState(false); //  State to track if modal is closed manually


  useEffect(() => {
    if (!isLoggedIn) {
      // Show modal after 10 seconds if not logged in and not closed manually
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [isLoggedIn, modalClosedManually]);

  const closeModal = () => {
    console.log("Close modal clicked"); // Debugging statement
    setShowModal(false);
    setModalClosedManually(true); // Set state when modal is closed manually
  };

  useEffect(() => {
    initializeGA(); // Initialize GA when the app starts
  }, []);

  useEffect(() => {
    initializeMixPanel();
  }, []);

  // Defer LogRocket until after the first paint so it doesn't block initial render
  useEffect(() => {
    const id = window.requestIdleCallback
      ? window.requestIdleCallback(() => LogRocket.init("ozgv5h/modalx"))
      : setTimeout(() => LogRocket.init("ozgv5h/modalx"), 0);
    return () => {
      if (window.requestIdleCallback) window.cancelIdleCallback(id);
      else clearTimeout(id);
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('isViUser') === 'true') {
      return;
    }

    const handleAuthError = async (error) => {
      if (error.code === 'auth/user-token-expired' || 
          error.code === 'auth/invalid-user-token' ||
          error.code === 'auth/user-disabled' ||
          error.message?.includes('invalid-authentication-credentials') ||
          error.message?.includes('auth/invalid-refresh-token') ||
          error.message?.includes('401')) {
        try {
          await auth.signOut();
        } catch (e) {
          console.error("Error signing out:", e);
        }
        clearAppStorage();
        window.location.href = '/login';
      }
    };

    let isFirstAuthCheck = true;
    const unsubscribe = auth.onIdTokenChanged(async (user) => {
      if (user) {
        try {
          const token = await user.getIdToken();
          localStorage.setItem("token", token);
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem("userId", user.uid);
          localStorage.setItem("lastTokenRefresh", Date.now().toString());
        } catch (error) {
          console.error("Token error on auth change:", error);
          handleAuthError(error);
        }
      } else if (!isFirstAuthCheck && localStorage.getItem("isLoggedIn")) {
        localStorage.removeItem("token");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("userId");
        localStorage.removeItem("lastTokenRefresh");
      }
      isFirstAuthCheck = false;
    });

    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible" && auth.currentUser) {
        try {
          const token = await auth.currentUser.getIdToken();
          localStorage.setItem("token", token);
        } catch (error) {
          console.error("Token refresh on visibility change failed:", error);
          handleAuthError(error);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      unsubscribe();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Router>
      <ViAuthProvider>
        <ViAuthWrapper>
          <AuthProvider>
            <UIProvider>
              <DailyLimitExceedProvider>
                <CreditRechargeProvider>
                  <RouteChangeTracker />
                  <NavigationTracker />
                  <Suspense fallback={null}>
                  <PreloaderRemover />
                  <Routes>
                <Route path="/userJourney" element={<PrivateRoute />}>
                  <Route path="/userJourney" element={<UserJourney />} />
                </Route>

                {/* Workspace Routes */}
                <Route path="/workspace" element={<WorkspaceLayout />}>
                  <Route index element={<Workspace />} />{" "}
                  {/* Matches exactly /workspace */}
                  <Route path="trackwithmodalx" element={<WorkSpaceTrack />} />
                  <Route
                    path="trackwithmodalx/:id"
                    element={<WebSiteAllUpdatePage />}
                  />
                  <Route path="gallery" element={<UserGallery />} />
                  <Route path=":id" element={<Workspace />} />
                  <Route
                    path="voiceagent"
                    element={
                      <SMBGuard>
                        <VoiceAgent />
                      </SMBGuard>
                    }
                  />
                </Route>

                <Route>
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:blogTitle" element={<BlogPage />} />
                </Route>

                {/* Payment Routes */}
                <Route
                  path="/paymentfail"
                  element={
                    <WorkspaceProvider>
                      <PaymentFail />
                    </WorkspaceProvider>
                  }
                />
                <Route
                  path="/paymentsuccess"
                  element={
                    <WorkspaceProvider>
                      <PaymentSuccess />
                    </WorkspaceProvider>
                  }
                />
                <Route
                  path="/paymentsuccess/plus"
                  element={
                    <WorkspaceProvider>
                      <PaymentSuccessForPlus />
                    </WorkspaceProvider>
                  }
                />
                <Route
                  path="/paymentsuccess/smb"
                  element={
                    <WorkspaceProvider>
                      <PaymentSuccessForSmb />
                    </WorkspaceProvider>
                  }
                />

                {/* Logout Route */}
                <Route
                  path="/logout"
                  element={
                    <WorkspaceProvider>
                      <LogOut />
                    </WorkspaceProvider>
                  }
                />

                {/* Public Routes */}
                <Route path="/" element={<PublicRoute />}>
                  <Route path="/home" element={<Home />} />
                  <Route path="/" element={<ViRootRedirect />} />
                  <Route path="/tools" element={<Tools />} />
                  <Route path="/landing" element={<Landing />} />
                  <Route path="/docs" element={<Documentation />} />
                  <Route path="/api" element={<ApiDocs />} />
                  {/* <Route path="/blog" element={<Blog />} /> */}
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/career" element={<Career />} />
                  <Route path="/share/:token" element={<ShareProject />} />
                  <Route path="/admin" element={<ClientLandingPage />} />
                  <Route path="/admin/:tab" element={<ClientLandingPage />} />
                  <Route path="/publicview" element={<PublicLinkView />} />
                  <Route path="/newpage" element={<NewPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/reset" element={<ResetPassword />} />
                  <Route
                    path="/emailverificationfailed"
                    element={<EmailVerificationPageFailed />}
                  />
                  <Route path="/vic" element={<ViCallingAgentRedirect />} />
                </Route>

                {/* Other Routes */}
                <Route
                  path="/presentationgallery"
                  element={<PresentationGallery />}
                />
                <Route path="/blogarticle" element={<BlogArticle />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/termsofservice" element={<TermsOfService />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/aboutus" element={<Aboutus />} />
                <Route path="/safety" element={<Safety />} />
                <Route
                  path="/marketingagencies"
                  element={<MarketingAgencies />}
                />
                <Route path="/audiogallery" element={<AudioGallery />} />
                <Route path="/imagegallery" element={<ImageGallery />} />
                <Route path="/videogallery" element={<VideoGallery />} />
                <Route path="/usecases" element={<UseCases />} />
                <Route path="/casestudy" element={<CaseStudy />} />
                <Route path="/pricing" element={<PricePage />} />
                <Route path="/agent" element={<CallingAgent />} />
                <Route path="/agent/india" element={<NewLandingPage />} />
                <Route path="/verify" element={<VerifyEmailModal />} />
                <Route
                  path="/emailverifedsuccess"
                  element={<VerifiedEmail />}
                />
                <Route path="/videoGenerate" element={<VideoGenerate />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/settings/profile" element={<ProfileSettings />} />
                <Route path="/settings/report-issue" element={<ReportIssue />} />
                <Route path="/settings/request-feature" element={<ReportIssue />} />

                {/* SMB Setup Route */}
                <Route path="/smb-setup" element={<SmbSetupPage />} />

                {/* Fallback Route */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>

              {/* {showModal && !isLoggedIn && (
            <Modal closeModal={closeModal} />
          )} */}
                  </Suspense>
                </CreditRechargeProvider>
              </DailyLimitExceedProvider>
            </UIProvider>
          </AuthProvider>
        </ViAuthWrapper>
      </ViAuthProvider>
    </Router>
  );
};

const Modal = ({ closeModal }) => {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const modalStyle = {
    position: "fixed",
    top: 0,
    right: 0, // Adjusted position to top right
    margin: "50px",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    borderRadius: "20px",
  };

  const contentStyle = {
    backgroundColor: "#0d0d0d",
    padding: "20px",
    borderRadius: "20px",
    position: "relative",
  };

  const closeStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
  };
  const handleGoogleSignUp = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      if (result.user.emailVerified) {
        setUser(result.user.emailVerified);
        localStorage.setItem("isLoggedIn", true);
        const token = await result.user.getIdToken();
        localStorage.setItem("token", token);
        closeModal();
        window.location.href = "/workspace";
      } else {
        localStorage.setItem("isLoggedIn", "");
      }
    } catch (error) {
      console.error("Error signing up with Google:", error.message);
    }
  };

  return (
    <div style={modalStyle}>
      <div style={contentStyle}>
        <span style={closeStyle} onClick={closeModal}>
          &times;
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <img
            src={require(`./assets/transparent-google-logo-google-logo-with-multicolored-g-and-1710875781697.png`)}
            style={{ width: "15px", height: "15px" }}
          />
          <p style={{ margin: "auto", fontSize: ".9rem", color: "white" }}>
            Sign in to Modalx.ai using google.com
          </p>
        </div>
        <p style={{ color: "grey", width: "100%" }}>
          ------------------------------------------------
        </p>
        <button
          onClick={() => handleGoogleSignUp()}
          style={{
            width: "100%",
            borderRadius: "10px",
            backgroundColor: "#0d6efd",
            fontSize: ".9rem",
            border: "none",
            padding: "10px",
          }}
        >
          Continue with google
        </button>
      </div>
    </div>
  );
};

export default App;

// <Routes>
//     <Route path="/userJourney" element={<PrivateRoute />}>
//       <Route path="/userJourney" element={<UserJourney />} />
//     </Route>
//     <Route path="/workspace" element={<PublicRoute />}>
//       <Route
//         path="/workspace/:id"
//         element={
//           <Sentry.ErrorBoundary>
//             <WorkspaceProvider>
//               <Workspace/>
//             </WorkspaceProvider>
//           </Sentry.ErrorBoundary>

//         }
//       />
//       <Route path="/workspace" element={<WorkspaceLayout />}>
//         <Route path="" element={<Workspace />} />
//         <Route path="trackwithmodalx" element={<WorkSpaceTrack />} />
//         <Route path="trackwithmodalx/:id" element={<WebSiteAllUpdatePage />} />
//       </Route>

//     </Route>
//     <Route
//       path="/paymentfail"
//       element={
//         <WorkspaceProvider>
//           <PaymentFail />
//         </WorkspaceProvider>
//       }
//     />

//     <Route
//       path="/paymentsuccess"
//       element={
//         <WorkspaceProvider>
//           <PaymentSuccess />
//         </WorkspaceProvider>
//       }
//     />

//     <Route
//       path="/logout"
//       element={
//         <WorkspaceProvider>
//           <LogOut />
//         </WorkspaceProvider>
//       }
//     />

//     <Route path="/" element={<PublicRoute />}>
//       <Route path="/" element={<Home />} />
//       <Route path="/tools" element={<Tools />} />
//       <Route path="/landing" element={<Landing />} />
//       <Route path="/docs" element={<Documentation />} />
//       <Route path="/api" element={<ApiDocs />} />
//       <Route path="/blog" element={<Blog />} />
//       <Route path="/terms" element={<Terms />} />
//       <Route path="/privacy" element={<Privacy />} />
//       <Route path="/career" element={<Career />} />
//       <Route path="/share/:token" element={<ShareProject />} />

//       {/* <Route path="/exclusive-access/login" element={<SignUpLogIn />}/> */}

//       <Route path="/admin" element={<ClientLandingPage />} />
//       <Route path="/publicview" element={<PublicLinkView />} />
//       <Route path="/newpage" element={<NewPage />} />
//     </Route>
//     <Route path="*" element={<Navigate to="/" replace />} />

//     <Route path="/presentationgallery" element={<PresentationGallery />} />
//     <Route path="/blogarticle" element={<BlogArticle />} />
//     <Route path="/faq" element={<FAQ />} />
//     <Route path="/termsofservice" element={<TermsOfService />} />
//     <Route path="/privacypolicy" element={<PrivacyPolicy />} />
//     <Route path="/contact" element={<Contact />} />

//     <Route path="/aboutus" element={<Aboutus />} />
//     <Route path="/safety" element={<Safety />} />
//     <Route path="/marketingagencies" element={<MarketingAgencies />} />
//     <Route path="/audiogallery" element={<AudioGallery />} />
//     <Route path="/imagegallery" element={<ImageGallery />} />
//     <Route path="/videogallery" element={<VideoGallery />} />
//     <Route path="/usecases" element={<UseCases />} />
//     <Route path="/casestudy" element={<CaseStudy />} />
//   </Routes>
